import { Component, OnDestroy } from '@angular/core';
import { TokenService } from '../../services/token.service';

@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  styleUrls: ['./user-dropdown.component.scss']
})
export class UserDropdownComponent implements OnDestroy {

  menuOpen = false;
  inElement = false;
  userInfo;
  name: string = 'User';
  _subscription;

  constructor(private tokenService: TokenService) {
    // subscribed to changes in user
    this._subscription = tokenService.currentUserChange.subscribe((user) => {
      this.userInfo = user;
      if (user) {
        this.name = user.firstName;
      }
    });
  }

  exitMenu() {
    this.inElement = false;
    setTimeout(() => {
      if (!this.inElement) {
        this.menuOpen = false;
      }
    }, 500);
  }

  enterMenu() {
    this.inElement = true;
  }

  goToOrders() {
    window.location.href =  'https://www.supplyhub.com/user/orders';
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/navbar/user-dropdown/user-dropdown.component.ts